import { Lock } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

/**
 * Rendered by ra-core on `/access-denied` when `useRequireAccess` refuses a
 * page (e.g. a non-admin opening the users list or the settings).
 */
export const AccessDenied = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <Lock className="h-10 w-10 text-muted-foreground" />
      <h1 className="text-2xl font-semibold">
        {translate("ra.page.access_denied")}
      </h1>
      <p className="text-muted-foreground">
        {translate("ra.message.access_denied")}
      </p>
      <Button asChild variant="outline">
        <Link to="/">{translate("ra.page.dashboard")}</Link>
      </Button>
    </div>
  );
};
